import React, { createContext, useState } from 'react'

export const TitleState = createContext<string|undefined>(undefined)
export const TitleDispatch = createContext<(state:string|undefined) => void>((state:string|undefined) => {})

export const TitleProvider = ({children}:any) => {
  const [state, setState] = useState<string|undefined>(undefined)

  return (
    <TitleState.Provider value={state}>
      <TitleDispatch.Provider value={setState}>
        {children}
      </TitleDispatch.Provider>
    </TitleState.Provider>
  )
}